<script setup lang="ts">
import SectionKidGeneral from './SectionKidGeneral.vue'
import ModalKidDelete from './modals/ModalKidDelete.vue'
import ModalKidAddDiscipline from './modals/ModalKidAddDiscipline.vue'

defineOptions({
  name: 'KidOverviewPage',
})
</script>

<template>
  <SectionKidGeneral />
  <ModalKidDelete />
  <ModalKidAddDiscipline />
</template>
